import { TableContentHeaderKey, UnmanagedBusinessHeaderKey } from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import { BaseTableContentViewModel } from '../../baseTableContentViewModel';
import { IUnmanagedBusiness } from '@/coreDomainsModule/entities/unmanagedBusiness';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { i18n } from '@/i18n';
import { UnmanagedBusinessService } from '@/coreDomainsModule/services/unmanagedBusinessService';

/**
 *　未管理取引のテーブル表示に使うロジック
 */
export class UnmanagedBusinessContentViewModel extends BaseTableContentViewModel {
  /**
   * 未管理取引の項目表示用
   * @param headerKey - ヘッダーキー
   * @param item - テーブルコンテンツアイテム
   */
  public displayOrderItem = (headerKey: UnmanagedBusinessHeaderKey, item: TableContentItem): string => {
    const business = item as IUnmanagedBusiness;
    switch (headerKey) {
      case 'inputDate':
        return DateService.convertIYearMonthDayToYYYYMMDDWithi18n(business.inputDate, true);
      case 'fileName':
        return business.fileName;
      case 'businessNumberNamedByUser':
        return business.businessNumber;
      case 'deliveryDestinationNumber':
        return business.salesDestinationNumber ?? '';
      case 'deliveryDestinationName':
        return business.salesDestinationName ?? '';
      case 'arrivalAmount':
        return business.arrival?.toString() ?? '';
      case 'saleQuantity':
        // business.salesResults.amountの合計を返す
        return UnmanagedBusinessService.calculateTotalSalesResult(business).toString() ?? '';
      case 'inventory':
        return business.inventory?.toString() ?? '';
      case 'stdInventoryIndex':
        return business.stdInventoryIndices?.toString() ?? '';
      case 'customerAnnounce-1':
        const currentMonth = new Date();
        currentMonth.setDate(1);
        // 当月の内示の合計を返す
        return UnmanagedBusinessService.calculateAnnounceAmountPerMonth(business, 0).toString() ?? ''.toString() ?? '';
      case 'customerAnnounce-2':
        const nextMonth = new Date();
        nextMonth.setDate(1);
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        // 次月の内示の合計を返す
        return UnmanagedBusinessService.calculateAnnounceAmountPerMonth(business, 1).toString() ?? '';
      case 'customerAnnounce-3':
        const monthAfterNext = new Date();
        monthAfterNext.setDate(1);
        monthAfterNext.setMonth(monthAfterNext.getMonth() + 2);
        // 再来月の内示の合計を返す
        return UnmanagedBusinessService.calculateAnnounceAmountPerMonth(business, 2).toString() ?? '';
      case 'registerBusiness':
        return '';
      case 'UnmanagedBusinessWarehouseNumber':
        return business.warehouseNumber;
      case 'UnmanagedBusinessSupplierNumber':
        return business.supplierNumber;
      case 'UnmanagedBusinessCustomerNumber':
        return business.customerNumber ?? '';
      case 'UnmanagedBusinessSalesDestinationNumber':
        return business.salesDestinationNumber ?? '';
    }
  };

  /**
   * ヘッダーキーがannounceの場合、対応する年月の文字列を返す
   * @param headerKey - ヘッダーキー
   */
  public getAnnounceYearMonth = (headerKey: TableContentHeaderKey): string => {
    const t = i18n.t;
    switch (headerKey) {
      case 'customerAnnounce-1':
        const now = new Date();
        now.setDate(1);
        now.setMonth(now.getMonth());
        return `${t('内示')} ${DateService.convertIYearMonthToYYYYMMWithSlash(DateService.convertDateToIYearMonth(now))}`;
      case 'customerAnnounce-2':
        const now2 = new Date();
        now2.setDate(1);
        now2.setMonth(now2.getMonth() + 1);
        return `${t('内示')} ${DateService.convertIYearMonthToYYYYMMWithSlash(DateService.convertDateToIYearMonth(now2))}`;
      case 'customerAnnounce-3':
        const now3 = new Date();
        now3.setDate(1);
        now3.setMonth(now3.getMonth() + 2);
        return `${t('内示')} ${DateService.convertIYearMonthToYYYYMMWithSlash(DateService.convertDateToIYearMonth(now3))}`;
      default:
        return `${t(headerKey)}`;
    }
  };
}
